import React, { useRef, useState } from 'react';
import { ChevronLeft, ChevronRight, Play, ChevronDown, Plus, ThumbsUp } from 'lucide-react';
import { IMG_W500, IMG, titleOf } from '../lib/tmdb';

export default function Row({ title, items = [], onPlay, large = false }) {
  const rowRef = useRef(null);
  const [moved, setMoved] = useState(false);

  const scroll = (dir) => {
    if (!rowRef.current) return;
    const { scrollLeft, clientWidth } = rowRef.current;
    const to = dir === 'left' ? scrollLeft - clientWidth * 0.9 : scrollLeft + clientWidth * 0.9;
    rowRef.current.scrollTo({ left: to, behavior: 'smooth' });
    setMoved(true);
  };

  const list = items.filter((i) => (large ? i.poster_path : i.backdrop_path || i.poster_path));

  return (
    <div className="mb-6 md:mb-10">
      <h2 className="text-base md:text-2xl font-bold text-[#e5e5e5] px-4 md:px-12 mb-2">
        {title}
      </h2>
      <div className="group relative">
        <button
          onClick={() => scroll('left')}
          className={`absolute left-0 top-0 bottom-0 z-20 w-12 bg-black/50 items-center justify-center hidden md:flex opacity-0 group-hover:opacity-100 transition-opacity ${moved ? '' : 'md:hidden'}`}
        >
          <ChevronLeft size={40} />
        </button>

        <div
          ref={rowRef}
          className="flex gap-1.5 md:gap-2 overflow-x-scroll no-scrollbar px-4 md:px-12 scroll-smooth"
        >
          {list.map((item) => (
            <div
              key={item.id}
              className={`relative flex-shrink-0 cursor-pointer transition-transform duration-300 hover:scale-105 hover:z-10 ${
                large ? 'w-32 md:w-48' : 'w-44 md:w-64'
              }`}
              onClick={() => onPlay(item)}
            >
              <img
                src={`${large ? IMG_W500 : IMG}${large ? item.poster_path : item.backdrop_path || item.poster_path}`}
                alt={titleOf(item)}
                className={`w-full object-cover rounded ${large ? 'h-48 md:h-72' : 'h-24 md:h-36'}`}
                loading="lazy"
              />
              {!large && (
                <div className="absolute inset-0 opacity-0 hover:opacity-100 bg-black/50 rounded flex flex-col justify-end p-3 transition-opacity">
                  <p className="text-xs md:text-sm font-semibold line-clamp-1 mb-2">{titleOf(item)}</p>
                  <div className="flex items-center gap-2">
                    <span className="bg-white text-black rounded-full p-1.5"><Play size={14} fill="black" /></span>
                    <span className="border border-white/60 rounded-full p-1.5"><Plus size={14} /></span>
                    <span className="border border-white/60 rounded-full p-1.5"><ThumbsUp size={14} /></span>
                    <span className="border border-white/60 rounded-full p-1.5 ml-auto"><ChevronDown size={14} /></span>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <button
          onClick={() => scroll('right')}
          className="absolute right-0 top-0 bottom-0 z-20 w-12 bg-black/50 items-center justify-center hidden md:flex opacity-0 group-hover:opacity-100 transition-opacity"
        >
          <ChevronRight size={40} />
        </button>
      </div>
    </div>
  );
}